<template>
  <div :id="chartId" style="width: 100%; height: 100%; min-height: 60px" />
</template>
<script setup>
import * as echarts from "echarts";
import "echarts-liquidfill";
import { buildUUID } from "@pureadmin/utils";

let myChart = null;
const uuid = buildUUID();
const chartId = ref(uuid);
const option = defineModel({
  default: {}
});

const optionReadonly = readonly({
  color: [
    "#0b79ff",
    "#25b60c",
    "#ff8f1f",
    "#f5212d",
    "#73c0de",
    "#3ba272",
    "#fc8452",
    "#ee6666",
    "#9a60b4",
    "#ea7ccc"
  ],
  tooltip: {
    trigger: "axis"
  },
  legend: {
    bottom: 0,
    left: "center"
  },
  grid: {
    top: 30,
    left: 0,
    right: 5,
    bottom: 30,
    containLabel: true
  },
  xAxis: {
    axisLabel: {
      showMinLabel: true,
      showMaxLabel: true,
      alignMinLabel: "left",
      alignMaxLabel: "right",
      overflow: "breakAll"
    }
  }
});
const options = ref({});
nextTick(() => {
  window.addEventListener("resize", resize); //绑定
  init();
  watch(
    () => option.value,
    val => {
      dispose();
      init();
    }
  );
});
// 组件卸载时执行的操作
onUnmounted(() => {
  //销毁
  dispose();
  if (myChart?.isDisposed()) {
    myChart = null;
  }
  // 这里可以执行一些清理工作，例如取消定时器、解除事件监听等
  window.removeEventListener("resize", resize); // 移除
});

// 响应容器大小的变化
function resize() {
  if (myChart) myChart.resize();
}
function dispose() {
  if (myChart) myChart.dispose();
}
// 基于准备好的dom，初始化echarts实例
function init() {
  myChart = echarts.init(document.getElementById(chartId.value));
  // 绘制图表
  setOption();
}
// 处理数据
function setOption() {
  options.value = Object.assign(
    {
      color: optionReadonly.color,
      legend: optionReadonly.legend,
      grid: optionReadonly.grid,
      tooltip: optionReadonly.tooltip
    },
    option.value
  );
  // 统一设置axisLabel样式
  if (options.value?.xAxis) {
    options.value.xAxis.axisLabel = {
      ...options.value.xAxis.axisLabel,
      ...optionReadonly.xAxis.axisLabel
    };
  }
  myChart.setOption(options.value);
}
</script>
<style scoped lang="scss"></style>
